module.exports = __webpack_public_path__ + "img/李永涛.bc76b4ef.jpg";